// extracted by mini-css-extract-plugin
export default {"blood":"Blood_blood__BX5KO","bloodSvg":"Blood_bloodSvg__VCcfO","bloodWrapper":"Blood_bloodWrapper__9rPP9"};